import { render, staticRenderFns } from "./CommonModalWithAmountStatusUpdate.vue?vue&type=template&id=5b1f45ce&lang=pug&"
import script from "./CommonModalWithAmountStatusUpdate.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithAmountStatusUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithAmountStatusUpdate.vue?vue&type=style&index=0&id=5b1f45ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports